var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1388 7.87321V6.08404C15.1388 3.98987 13.3573 2.29154 11.1607 2.29154C8.96406 2.28237 7.17563 3.97237 7.16602 6.06737V6.08404V7.87321",
    stroke: "#20222C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4917 17.7081H7.81266C5.98228 17.7081 4.49805 16.294 4.49805 14.5481V10.974C4.49805 9.22813 5.98228 7.81396 7.81266 7.81396H14.4917C16.3221 7.81396 17.8063 9.22813 17.8063 10.974V14.5481C17.8063 16.294 16.3221 17.7081 14.4917 17.7081Z",
    stroke: "#20222C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1524 11.8354V13.6863",
    stroke: "#20222C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7f48861d79490c5e9cdcbdc72dcde7f5.svg";
export { ForwardRef as ReactComponent };